import "whatwg-fetch";
import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from "react-redux";

import { appConfig } from "../config";
import { initGoogleTracking } from "./utils";
import {
	FundExplorer,
	FundFactsContainer,
	PageAllocationContainer,
	PageCharacteristicsContainer,
	PageReasonToInvestContainer,
	PageChargesContainer,
	PageCommentaryContainer,
	PageHistoricContainer,
	PageLiteratureContainer,
	PageOverviewContainer,
	PagePerformanceContainer,
	PageSearchContainer,
	PageShareClassSelectorContainer,
	WatchlistContainer,
	PageHeaderContainer,
	PageRatingsContainer,
	PageImportantInformationContainer,
	MiniFundFinderContainer,
	FundExplorerPrint,
	HistoricalPricesPrint,
	HistoricalNavPricesPrint,
	HistoricalSharePricesPrint,
	DistributionRatesPrint,
	RankiaPerformanceContainer
} from "./containers";
import { docReady, isNullOrUndefined, safe, getAppParams } from "./utils";
import { IS_DEV, initializeStore } from "./config";

const initialState = window["__INITIAL_STATE__"] || {};
const store = initializeStore(initialState);
const baseId = `${ appConfig.projectIdentifier }_tools`;
const rootElement = document.getElementById(baseId);

const targets = {
	rankia: {
		elementId: `${ baseId }_rankia`,
		component: <RankiaPerformanceContainer></RankiaPerformanceContainer>
	},
	watchlist: {
		elementId: `${ baseId }_watchlist`,
		component: <WatchlistContainer></WatchlistContainer>
	},
	miniexplorer: {
		elementId: `${ baseId }_miniexplorer`,
		component: <MiniFundFinderContainer></MiniFundFinderContainer>
	},
	header: {
		elementId: `${ baseId }_header`,
		component: <PageHeaderContainer></PageHeaderContainer>
	},
	search: {
		elementId: `${ baseId }_search`,
		component: <PageSearchContainer></PageSearchContainer>
	},
	commentary: {
		elementId: `${ baseId }_commentary`,
		component: <PageCommentaryContainer></PageCommentaryContainer>
	},
	reasonstoinvest: {
		elementId: `${ baseId }_reasonstoinvest`,
		component: <PageReasonToInvestContainer></PageReasonToInvestContainer>
	},
	performance: {
		elementId: `${ baseId }_performance`,
		component: <PagePerformanceContainer></PagePerformanceContainer>
	},
	facts: {
		elementId: `${ baseId }_facts`,
		component: <FundFactsContainer></FundFactsContainer>
	},
	characteristics: {
		elementId: `${ baseId }_characteristics`,
		component: <PageCharacteristicsContainer></PageCharacteristicsContainer>
	},
	charges: {
		elementId: `${ baseId }_charges`,
		component: <PageChargesContainer></PageChargesContainer>
	},
	allocation: {
		elementId: `${ baseId }_allocation`,
		component: <PageAllocationContainer></PageAllocationContainer>
	},

	historic: {
		elementId: `${ baseId }_historic`,
		component: <PageHistoricContainer></PageHistoricContainer>
	},
	explorer: {
		elementId: `${ baseId }_explorer`,
		component: <FundExplorer></FundExplorer>
	},
	explorerPrint: {
		elementId: `${ baseId }_explorer_print`,
		component: <FundExplorerPrint></FundExplorerPrint>
	},
	historicalPricesPrint: {
		elementId: `${ baseId }_historical_prices_print`,
		component: <HistoricalPricesPrint></HistoricalPricesPrint>
	},
	historicalSharePricesPrint: {
		elementId: `${ baseId }_historical_share_prices_print`,
		component: <HistoricalSharePricesPrint></HistoricalSharePricesPrint>
	},
	historicalNavPricesPrint: {
		elementId: `${ baseId }_historical_nav_prices_print`,
		component: <HistoricalNavPricesPrint></HistoricalNavPricesPrint>
	},
	distributionRatesPrint: {
		elementId: `${ baseId }_distribution_rates_print`,
		component: <DistributionRatesPrint></DistributionRatesPrint>
	},
	overview: {
		elementId: `${ baseId }_overview`,
		component: <PageOverviewContainer></PageOverviewContainer>
	},
	ratings: {
		elementId: `${ baseId }_ratings`,
		component: <PageRatingsContainer></PageRatingsContainer>
	},
	information: {
		elementId: `${ baseId }_information`,
		component: <PageImportantInformationContainer></PageImportantInformationContainer>
	},
	shareClassSelectorId: {
		elementId: `${ baseId }_shareClassSeletor`,
		component: <PageShareClassSelectorContainer></PageShareClassSelectorContainer>
	}
};

docReady(() => {
	initGoogleTracking();
	for (let key of Object.keys(targets)) {
		let target = targets[key];
		target.element = document.getElementById(target.elementId);
		if (!isNullOrUndefined(target.element) && !isNullOrUndefined(target.component)) {
			let appParams = getAppParams(target.element);
			if (appParams.clienttype !== "dtc") {
				appParams.fundExplorerUrl = appConfig.envDetails[process.env.NODE_ENV].fundExplorerUrls[appParams.clienttype || "diw"][appParams.productrange];
			}
			let entryJSX = (
				<Provider store={ store } >
					{ React.cloneElement(target.component, { appParams }) }
				</Provider>
			);
			render(entryJSX, target.element);
		}
	}
});


// WEBPACK FOOTER //
// ./src/client/index.tsx